import React from 'react'
import { Sidebar } from '../../../components/Sidebar/Sidebar'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { Baseurl } from '../../../../Config/Baseurl'
import { useEffect } from 'react'
import { toast } from 'react-toastify'
import { TiDeleteOutline } from 'react-icons/ti'
import 'react-toastify/dist/ReactToastify.css'
import DataTable from 'react-data-table-component'
import { useState } from 'react'
import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css'

export const ViewQuestion = () => {
  toast.configure()
  const [questions, setQuestions] = useState([])
  const [id, setId] = useState()
  const [data, setData] = useState([])

  // fetch all questions ans subjects
  const getQuestions = async () => {
    await axios
      .get(Baseurl.nodeLocal + 'question/fetchAllQuestions')
      .then((res) => {
        setQuestions(res.data.data)
      })
      .catch((error) => {})

    await axios
      .get(Baseurl.nodeLocal + 'subject/fetchAllSubjects')
      .then((res) => {
        setData(res.data.data)
      })
      .catch((error) => {})
  }

  useEffect(() => {
    getQuestions()
  }, [])

  // fetch questions based on selected subject
  const getData = async (id) => {
    await axios
      .post(Baseurl.nodeLocal + 'question/fetchSubjectWiseQuestions', {
        sub_id: id,
      })
      .then((res) => {
        setQuestions(res.data.data)
      })
      .catch((err) => {})
  }

  // delete question
  const deleteQuestion = async (id) => {
    await axios
      .post(Baseurl.nodeLocal + 'question/deleteQuestion', {
        que_id: id,
      })
      .then((response) => {
        toast.success(response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
        setTimeout(() => {
          window.location.reload(false)
        }, 2000)
      })
      .catch((error) => {
        toast.error(error.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
      })
  }

  // columns to display data of the table
  const columns = [
    {
      name: 'Sr.no',
      selector: (row) => row.que_id,
      sortable: true,
      width: '80px',
    },

    {
      name: 'Question',
      selector: (row) => {
        return (
          <Tippy content={row.que_text} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.que_text}
            </p>
          </Tippy>
        )
      },

      width: '300px',
    },
    {
      name: 'Option 1',
      selector: (row) => {
        return (
          <Tippy content={row.opt1} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.opt1}
            </p>
          </Tippy>
        )
      },

      width: '100px',
    },
    {
      name: 'Option 2',
      selector: (row) => {
        return (
          <Tippy content={row.opt2} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.opt2}
            </p>
          </Tippy>
        )
      },

      width: '100px',
    },
    {
      name: 'Option 3',
      selector: (row) => {
        return (
          <Tippy content={row.opt3} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.opt3}
            </p>
          </Tippy>
        )
      },

      width: '100px',
    },
    {
      name: 'Option 4',
      selector: (row) => {
        return (
          <Tippy content={row.opt4} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.opt4}
            </p>
          </Tippy>
        )
      },

      width: '100px',
    },
    {
      name: 'Correct Answer',
      selector: (row) => {
        return (
          <Tippy content={row.correct_ans} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.correct_ans}
            </p>
          </Tippy>
        )
      },
    },

    {
      name: 'Action',
      cell: (row) => (
        <>
          <TiDeleteOutline
            className="deletebtn"
            onClick={() => {
              setId(row.que_id)
            }}
            data-bs-target="#deleteModal"
            data-bs-toggle="modal"
          />
        </>
      ),
    },
  ]

  return (
    <div className="row">
      <div className="col-md-2">
        <Sidebar />
      </div>
      <div className="col-md-9 mx-5 mt-4 p-2">
        {/*breadcrumbs  */}
        <div className="d-flex justify-contetn-center">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/examdashboard" className="link text-primary">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                View Questions
              </li>
            </ol>
          </nav>
        </div>
        <div className="viewQueheader">
          <h4>View Questions</h4>
          <Link to="/addquestion" className="link">
            <div className="addQuesBtn">
              <button className="btn btn-primary ">Add new Question</button>
            </div>
          </Link>
        </div>
        <div className="question mt-5">
          {/* data table */}
          <DataTable
            columns={columns}
            data={questions}
            pagination
            highlightOnHover
            subHeader
            subHeaderComponent={
              <div className="row w-50 d-flex justify-content-end">
                <div className="col-md-6 form-floating">
                  {/* dropdown to select subject for filter */}
                  <select
                    className="form-select"
                    id="floatingSelect"
                    aria-label="Floating label select example"
                    onChange={(e) => getData(e.target.value)}
                  >
                    <option value="Select" selected disabled>
                      Select
                    </option>
                    {/* mapping the list of subjects */}
                    {data?.map((i, index) => {
                      return (
                        <option value={i.sub_id} key={index}>
                          {i.name}
                        </option>
                      )
                    })}
                  </select>
                  <label
                    htmlFor="floatingSelect"
                    style={{ marginLeft: '0.8rem' }}
                  >
                    Select Subject
                  </label>
                </div>
              </div>
            }
          />
        </div>
      </div>
      {/* modal for confirmation of deletion */}
      <div
        className="modal"
        tabIndex="-1"
        id="deleteModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Alert</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <p>Are you sure you want to delete the data ?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  deleteQuestion(id)
                }}
                data-bs-dismiss="modal"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
